import React, { useState, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { Context } from "../../../../utils/context";
import JobDescriptionModal from "../../JobDescriptionModel/JobDescriptionModal";
import "./SixthJobMobile.css"; // Ensure this matches your CSS filename

const SixthJobMobile = ({ jobData = [] }) => {
  const [modalShow, setModalShow] = useState(false);
  const [selectedJob, setSelectedJob] = useState({});
  const { NoDataAnimations } = useContext(Context);

  return (
    <section className="sixth-job-tab-mobile">
      <div className="mobile-applied-container">
        {/* Mobile Header Panel */}
        <div className="d-flex align-items-center justify-content-between mb-3 px-1">
          <span className="mobile-header-title">Applications Status</span>
          <Link to="/dashboard-job" className="mobile-back-dash-link">
            Dashboard <FontAwesomeIcon icon="fa-solid fa-chevron-right" className="ms-1 small" />
          </Link>
        </div>

        {/* Dynamic Mobile Cards Stack */}
        <div className="mobile-cards-stack">
          {jobData?.map((value, index) => (
            <div className="modern-mobile-job-card" key={value?.id || index}>
              {/* Top Header Row */}
              <div className="d-flex justify-content-between align-items-start gap-2 mb-2">
                <div className="mobile-role-info">
                  <h4 className="mobile-job-role m-0">
                    {value?.job?.job_title?.name || value?.job?.role?.name}
                  </h4>
                  <span className="mobile-company-lbl">{value?.job?.company?.name}</span>
                </div>
                <button
                  className="mobile-action-view-btn"
                  onClick={() => {
                    setSelectedJob(value?.job);
                    setModalShow(true);
                  }}
                >
                  View
                </button>
              </div>

              {/* Geo Location Tracker */}
              <div className="mobile-meta-location mb-3">
                <FontAwesomeIcon icon="fa-solid fa-location-dot" className="me-1" />
                {value?.job?.job_work_locations?.slice(0, 2).map((type) => type?.city?.name).join(", ") || "Remote"}
              </div>

              {/* Horizontal Application Milestone Timeline Tracker */}
              {value?.job?.application_status_histories && value.job.application_status_histories.length > 0 && (
                <div className="mobile-timeline-footer-track">
                  {value?.job?.application_status_histories?.map((status, statusIndex) => (
                    <div className="mobile-timeline-pill-node" key={statusIndex}>
                      <span className="mobile-pill-status-txt">
                        {status?.application_status?.name}
                      </span>
                      <span className="mobile-pill-date-txt">
                        {new Date(status?.createdAt).toLocaleDateString("en-US", {
                          day: "2-digit",
                          month: "short",
                        })}
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}

          {/* Fallback Empty State Window */}
          {jobData?.length === 0 && (
            <div className="mobile-empty-state-card text-center py-4">
              <NoDataAnimations />
              <p className="text-muted small mt-2">No active job applications found.</p>
            </div>
          )}
        </div>
      </div>

      {/* Embedded Operational Viewport Portal Modal */}
      <JobDescriptionModal
        show={modalShow}
        data={selectedJob}
        title="Job Details & Requirements"
        onHide={() => setModalShow(false)}
      />
    </section>
  );
};

export default SixthJobMobile;